var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9998C18.6274 23.9998 24 18.6272 24 11.9998C24 5.37234 18.6274 -0.000244141 12 -0.000244141C5.37258 -0.000244141 0 5.37234 0 11.9998C0 18.6272 5.37258 23.9998 12 23.9998Z",
    fill: "#007AB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1707 12.9653V17.9127H16.3024V13.2969C16.3024 12.1379 15.8883 11.3465 14.8497 11.3465C14.0572 11.3465 13.5864 11.8793 13.3785 12.3953C13.3029 12.5797 13.2835 12.8357 13.2835 13.0943V17.9125H10.4149C10.4149 17.9125 10.4534 10.0949 10.4149 9.28563H13.2837V10.5081C13.2779 10.5178 13.2698 10.5272 13.2647 10.5364H13.2837V10.5081C13.6649 9.92159 14.3447 9.08306 15.8688 9.08306C17.7559 9.08306 19.1707 10.316 19.1707 12.9653ZM7.41417 5.1272C6.43296 5.1272 5.79102 5.77128 5.79102 6.61752C5.79102 7.44578 6.41435 8.10848 7.37653 8.10848H7.39514C8.3956 8.10848 9.01765 7.44578 9.01765 6.61752C8.99862 5.77128 8.3956 5.1272 7.41417 5.1272ZM5.9615 17.9127H8.82898V9.28563H5.9615V17.9127Z",
    fill: "#F1F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7c10debec75a695fbb7fbf6cf1cf9410.svg";
export { ForwardRef as ReactComponent };